export default function SalesContractsPage() {
    return (
        <div className="bg-white rounded-2xl shadow p-6">
            <h2 className="text-lg font-semibold mb-4">Sales Contracts</h2>
            <p className="text-sm text-gray-600">
                Review and manage customer contracts here.
            </p>
        </div>
    );
}
